import * as Yup from 'yup';
import { YUP_VALIDATIONS } from '@plug/helpers/yup-helpers';

export const DefaultBankInformationSchema = Yup.object().shape({
  bank: YUP_VALIDATIONS.bank.notRequired(),
  bankType: YUP_VALIDATIONS.bankType.notRequired(),
  account: YUP_VALIDATIONS.account.notRequired(),
  accountDigit: YUP_VALIDATIONS.accountDigit.notRequired(),
  accountHolderName: YUP_VALIDATIONS.accountHolderName.notRequired(),
  agency: YUP_VALIDATIONS.agency.notRequired(),
});

export const RequiredBankInformationSchema = Yup.object().shape({
  bank: YUP_VALIDATIONS.bank,
  bankType: YUP_VALIDATIONS.bankType,
  account: YUP_VALIDATIONS.account,
  accountDigit: YUP_VALIDATIONS.accountDigit,
  accountHolderName: YUP_VALIDATIONS.accountHolderName,
  agency: YUP_VALIDATIONS.agency,
  termsAndPolitics: YUP_VALIDATIONS.termsAndPolitics,
});
